var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{staticClass:"up",attrs:{"color":_vm.type=='success'?'':_vm.type},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v(" "+_vm._s(_vm.message)+" "),_c('v-btn',{attrs:{"color":_vm.type=='success'? 'primary': 'alert',"text":""},on:{"click":_vm.clearAlert}},[_vm._v(" Chiudi ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }